import React from 'react'
import { motion } from "framer-motion";
import Slider from "react-slick";
import OptimizedImage from "./OptimizedImage";

const HomeSection5 = ({ section5, ClientsInView, i18n }) => {

    const clientsCount = Array.isArray(section5?.clientsData) ? section5.clientsData.length : 0;
    const isStatic = clientsCount <= 5;

    const settings = {
        slidesToShow: Math.min(6, clientsCount || 6),
        slidesToScroll: 1,
        infinite: clientsCount > Math.min(6, clientsCount || 6),
        autoplay: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: true,
        responsive: [
            { breakpoint: 576, settings: { slidesToShow: Math.min(2, clientsCount || 2) } },
            { breakpoint: 768, settings: { slidesToShow: Math.min(4, clientsCount || 4) } },
            { breakpoint: 992, settings: { slidesToShow: Math.min(5, clientsCount || 5) } },
            { breakpoint: 1200, settings: { slidesToShow: Math.min(5, clientsCount || 5) } },
        ],
        speed: 400,
        cssEase: "ease-in-out",
    };

    return (
        <div>
            <section id="clients" className="clients py-3 mt-3 mb-3">
                <div className="container">
                    <motion.h2
                        className="text-center text-dark  fw-bold"
                        initial={{ opacity: 0, y: 50 }}
                        animate={ClientsInView ? { opacity: 1, y: 0 } : {}}
                        transition={{ duration: 1 }}
                    >
                        {i18n.language === "en" ? section5?.titleHeadEn : section5?.titleHeadAr}
                    </motion.h2>

                    <Slider {...settings} className="clients-slider">
                        {clientsCount > 0 ? (
                            section5.clientsData.map((client, index) => (
                                <div key={client.id || index}>
                                    <motion.div
                                        className="client-logo-wrapper"
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={ClientsInView ? { opacity: 1, scale: 1 } : {}}
                                        transition={{ duration: 1 }}
                                    >
                                        <OptimizedImage
                                            src={client.img}
                                            alt={client.alt || "Client"}
                                            priority={false}
                                            className="img-fluid client-logo"
                                            objectFit="contain"
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                maxHeight: '100%',
                                                maxWidth: '100%',
                                                margin: '0 auto'
                                            }}
                                        />
                                    </motion.div>
                                </div>
                            ))
                        ) : (
                            <p className="text-center text-dark">No clients available</p>
                        )}
                    </Slider>
                </div>
            </section>
        </div>
    )
}

export default HomeSection5;
